module.exports = __webpack_public_path__ + "img/product_73.9d2ee0c.webp";